import AccountActions from './AccountActions.component';

export default AccountActions;
